/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


export const formatDuration = (ms) =>
{
  const seconds = Math.max(0, Math.floor(ms / 1000));

  const minutes = Math.floor(seconds / 60);

  const hours = Math.floor(minutes / 60);

  if (hours > 0)
  {
    return hours + 'h ' + (minutes % 60) + 'm';
  }

  if (minutes > 0)
  {
    return minutes + 'm ' + (seconds % 60) + 's';
  }

  return seconds + 's';
};


// Single-unit variant: floors to whole hours past one, minutes below, seconds
// under a minute.
export const formatCompactDuration = (ms) =>
{
  const seconds = Math.max(0, Math.floor(ms / 1000));

  const minutes = Math.floor(seconds / 60);

  if (minutes >= 60)
  {
    return Math.floor(minutes / 60) + 'h';
  }

  if (minutes > 0)
  {
    return minutes + 'm';
  }

  return seconds + 's';
};
